export default "__VITE_ASSET__BZdksCq$__"